export enum TipoGeracaoSkuEnum {
    Manual = 1,
    Sequencial = 2,
    SequencialEAN13 = 3,
}